import Library from '../utility/Library';
import Reader from './blueprint/Reader';
import User from '../../User';

const ATTACK_INTENT = {"basis":[{"type":"triggers","index":0,"out":0},{"type":"parameters","index":1,"out":0}],"triggers":[{"type":"play","in":["false"],"to":1}],"actions":[{"type":"damage","in":[{"type":"parameters","index":3,"out":0},"this",{"type":"parameters","index":0,"out":0},"false"]},{"type":"if","in":[{"type":"parameters","index":2,"out":1}],"true":0}],"parameters":[{"type":"intfvar","in":["companiondamage"]},{"type":"compute","in":[{"type":"parameters","index":0,"out":0},"attack"]},{"type":"findenemy","in":["living enemy"]},{"type":"extremumenemy","in":[]}]};

export default class CompanionEntity {

	constructor (master) {

		this.master = master;
		this.model = master.player.champion.companion;
		if (this.model && this.model.model)
			User.learn("enemies", this.model.model.key);

		this.setupPatterns();
	}

	get id () { return "companion"; }

	get key () { return "companion"; }

	get skill () { return this.model.skill }

	/*haveIntent () {

		if (!this.patterns)
			return null;

		this.nointent = Math.floor(Math.random() * this.patterns.length);
		this.previousintent = this.nointent;
		this.master.notify('companionintent', this, this.nointent);
		return this.nointent;
	}

	loseIntent () {

		this.nointent = null;
		this.master.notify('companionintent', this, this.nointent);
	}

	get intent () {

		return this.nointent !== null && this.nointent !== undefined ? this.patterns[this.nointent] : null;
	}

	act () {

		if (this.intent) {
			let intent = this.intent;
			this.master.notify('companionact.before', this, intent.damage ? "attack" : "status");
			intent.act();
			this.master.notify('companionact', this, intent.damage ? "attack" : "status");
			delete this.nointent;
		}
	}*/

	act () {

		if (!this.patterns)
			return;
		if (!this.master.player.champion.getPassive("companionact") && Math.random() < 0.5)
			return; // 50% chance to act

		let intent = this.patterns[Math.floor(Math.random() * this.patterns.length)];
		this.master.setVariable("companiondamage", Math.round(2.8 * this.master.run.champion.level * (1 + Math.random() * 0.5) * this.model.multiplier));
		if (!intent.act)
			return;
		this.master.notify('companionact.before', this, intent.damage ? "attack" : "status");
		intent.act();
		this.master.notify('companionact', this, intent.damage ? "attack" : "status");
	}

	setupPatterns () {

		delete this.patterns;
		this.patterns = [{ blueprint: ATTACK_INTENT }, Object.assign({}, this.model.action)];
		this.patterns.forEach((pattern,i) => {
			if (!pattern.blueprint)
				return;
			this.computecode = i;
			pattern.blueprint = Reader.read(pattern.blueprint, this);
			delete this.computecode;
			let e = this.events[0];
			pattern.act = () => e();
			delete this.events;
		});
	}

	damage () {}
	heal () {}
	loseLife () {}
	gainblock () {}
	loseblock () {}
	die () {}
	apply () {}

	serialize () {

		return {
			nointent: this.nointent
		}
	}

	static build (master, src) {

		let companion = new CompanionEntity(master);
		companion.nointent = src.nointent;
		companion.setupPatterns();
		return companion;
	}
}
